import React from 'react';

function LayoutContent({
  element,
}: {
  element: React.JSX.Element;
}): React.JSX.Element {
  return <div className="content content--full">{element}</div>;
}

export default LayoutContent;
